import { c as _c } from "react/compiler-runtime";
import { AxeIcon } from "lucide-react";
import Icon from "@/components/icon";
import { BreadcrumbProvider, type Breadcrumb } from "@/features/breadcrumbs";
export const breadcrumb: Breadcrumb = {
  dirname: __dirname,
  title: "Weapons",
  icon: <Icon component={AxeIcon} />
};
export default function Layout(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <BreadcrumbProvider {...breadcrumb}>{children}</BreadcrumbProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}